export const scadaKeys = {
    all: ['scada'] as const,
    graphs: () => [...scadaKeys.all, 'graph'] as const,
    graph: (assetId: string) => [...scadaKeys.graphs(), assetId] as const,
    sseData: () => [...scadaKeys.all, 'sse'] as const,
    sseLive: (assetId: string) => [...scadaKeys.sseData(), 'live', assetId] as const,
    historical: () => [...scadaKeys.all, 'historical'] as const,
    historicalData: (assetId: string, timestamp: number) =>
        [...scadaKeys.historical(), assetId, timestamp] as const,
    entities: () => [...scadaKeys.all, 'entity'] as const,
    entity: (entityId: string) => [...scadaKeys.entities(), entityId] as const,
    pages: () => [...scadaKeys.all, 'pages'] as const,
    pagesList: (workspaceId: string) => [...scadaKeys.pages(), 'list', workspaceId] as const,
    pagesSearch: (workspaceId: string, query: string) =>
        [...scadaKeys.pages(), 'search', workspaceId, query] as const,
} as const;

export type ScadaQueryKeys = typeof scadaKeys;
